var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppNav'),_c('v-main',[(_vm.$store.getters['account/loggedin'])?_c('HomePage'):_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('h1',[_vm._v("Por favor, faça login para usar o sistema.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }